import Button from "components/Button";
import Dashboard from "components/Template/Dashboard";
import TextInputAuth from "components/TextInputAuth";
import PasswordCheck from "icons/password-check.svg";
import Confirm from "icons/confirm-circle-white.svg";
import React, { useEffect, useState } from "react";
import Loading from "components/Loading";
import { meEdit, meGet } from "services/me";
import { schemaAccountSettings } from "./validation";
import handleErrors from "helpers/handleErrors";
import Modal from "components/Modal";
import { ReactComponent as Close } from "icons/close-circle-gray.svg";
import { useHistory } from "react-router-dom";
import toastMessage from "helpers/handleToastMessage";
import { ToastContainer } from "react-toastify";
import { useAuth } from "context/auth";
import { passwordRequest } from "services/auth";

type Props = {};

const AccountSettingsIndex: React.FC<Props> = () => {
  let history = useHistory();

  const { reloadContextData } = useAuth();
  const [role, setRole] = useState("");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [oldEmail, setOldEmail] = useState("");
  const [entityName, setEntityName] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<any>();
  const [id, setId] = useState("");

  const [show, setShow] = useState(false);
  const [title, setTitle] = useState<number>(0);

  const me = async () => {
    try {
      setLoading(true);
      const { data } = await meGet();
      setFirstName(data.name.split(" ")[0]);
      setLastName(data.name.split(" ")[1]);
      setEntityName(
        data.role === "entity" ? data.entityName : "Bridge Talk Admin"
      );
      setOldEmail(data.email);
      setEmail(data.email);
      setId(data._id);
    } catch (error: any) {
      toastMessage({
        message: "Error, coupon not valid.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    me();

    const storageRole = localStorage.getItem("role");
    setRole(storageRole || "");
    // setRole(storageRole || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {}, []);

  const edit = async () => {
    try {
      setLoading(true);

      if (
        !schemaAccountSettings.isValidSync({
          firstName,
          lastName,
          entityName,
          email,
        })
      ) {
        handleErrors({
          schema: schemaAccountSettings,
          stateData: {
            firstName,
            lastName,
            entityName,
            email,
          },
          setErrorMessage: setErrors,
        });
        setLoading(false);
        return;
      }

      await meEdit({
        name: `${firstName} ${lastName}`,
        email,
        entityName,
      });

      reloadContextData();

      if (email !== oldEmail) {
        setTitle(1);
        setShow(true);
        setErrors({});
      } else {
        setShow(true);
        setTitle(2);
      }
    } catch (error: any) {
      if (error.response.data === undefined) {
        setErrors({ email: "Unable to update to this email" });
      }
    } finally {
      setLoading(false);
    }
  };

  const changePassword = async () => {
    try {
      setLoading(true);

      const { data } = await passwordRequest({ email, role });

      toastMessage({
        message: "Verification code send successfully.",
        type: "success",
      });

      history.push(`/account-settings/${id}/change-password`, {
        changeState: data.state,
      });
    } catch (_) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dashboard
      title={""}
      breadcrumb={[
        { name: "Dashboard", active: false, path: "/entity-management" },
        { name: "Account Settings", active: true },
      ]}
      children={
        <>
          <Modal
            show={show}
            children={
              <div className="w-full h-60 bg-bt-white p-6 rounded-md">
                <div className="flex flex-row justify-end mb-24">
                  <Close
                    width={28}
                    height={28}
                    className="cursor-pointer"
                    onClick={() => {
                      setShow(false);
                    }}
                  />
                </div>
                {title === 1 ? (
                  <>
                    <div className="flex flex-row items-center justify-center">
                      <span
                        className="font-sora font-light text-xl text-bt-green"
                        style={{
                          fontStyle: "normal",
                          fontWeight: 700,
                        }}
                      >
                        Email changed
                      </span>
                    </div>
                    <div className="flex flex-row items-center justify-center">
                      <span
                        className="font-sora font-light text-xl text-bt-green"
                        style={{
                          fontStyle: "normal",
                          fontWeight: 200,
                        }}
                      >
                        Please check your inbox to validate it
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="flex flex-row items-center justify-center">
                      <span
                        className="font-sora font-light text-3xl text-bt-green"
                        style={{
                          fontStyle: "normal",
                          fontWeight: 700,
                        }}
                      >
                        Your changes has been saved
                      </span>
                    </div>
                  </>
                )}
              </div>
            }
          />
          <Loading loading={loading} />
          <div className={"flex flex-row"}>
            <div className="flex flex-col w-1/2">
              <span
                className="text-2xl font-sora"
                style={{
                  fontStyle: "normal",
                  fontWeight: 600,
                  color: "#408E5A",
                }}
              >
                {firstName} {lastName}
              </span>
              <div className="mt-10">
                <div
                  className="flex w-32 h-32 rounded-full font-sora font-medium2 justify-center items-center text-bt-white text-6xl"
                  style={{ background: "#408E5A" }}
                >
                  {firstName.charAt(0)}
                </div>
              </div>
              <div
                className="mt-28 text-xl font-sora"
                style={{
                  fontStyle: "normal",
                  fontWeight: 600,
                  color: "#4F4F4F",
                }}
              >
                Organization
              </div>
              <div
                className="mt-4 font-sora text-sm"
                style={{
                  fontStyle: "normal",
                  fontWeight: 400,
                  color: "#85858A",
                }}
              >
                Visible on your public profile.
              </div>
              <div className="mt-8">
                <TextInputAuth
                  label="Organization name"
                  placeholder={"Organization name"}
                  value={entityName}
                  className="w-2/3"
                  onChange={(e: any) => setEntityName(e.target.value)}
                  isHelp={errors?.entityName}
                  helpText={errors?.entityName}
                  disabled={entityName === "Bridge Talk Admin" ? true : false}
                />
              </div>
            </div>
            <div className="flex flex-col w-1/2">
              <span
                className="text-2xl font-sora"
                style={{
                  fontStyle: "normal",
                  fontWeight: 600,
                  color: "#408E5A",
                }}
              >
                Your account
              </span>
              <div
                className="mt-8 text-xl font-sora"
                style={{
                  fontStyle: "normal",
                  fontWeight: 600,
                  color: "#4F4F4F",
                }}
              >
                Personal Details
              </div>
              <div
                className="mt-4 font-sora text-sm"
                style={{
                  fontStyle: "normal",
                  fontWeight: 400,
                  color: "#85858A",
                }}
              >
                Your personal information is never shared with other users.
              </div>
              <div className="flex flex-row mt-8">
                <div className="flex flex-col w-1/2 mr-2">
                  <TextInputAuth
                    label="First name"
                    placeholder={"First name"}
                    value={firstName}
                    onChange={(e: any) => setFirstName(e.target.value)}
                    isHelp={errors?.firstName}
                    helpText={errors?.firstName}
                  />
                </div>
                <div className="flex flex-col w-1/2 ml-2">
                  <TextInputAuth
                    label="Last name"
                    placeholder={"Last name"}
                    value={lastName}
                    onChange={(e: any) => setLastName(e.target.value)}
                    isHelp={errors?.lastName}
                    helpText={errors?.lastName}
                  />
                </div>
              </div>
              <div className="flex flex-row mt-6">
                <TextInputAuth
                  label="Email"
                  placeholder={"Email"}
                  value={email}
                  className="w-full"
                  onChange={(e: any) => setEmail(e.target.value)}
                  isHelp={errors?.email}
                  helpText={errors?.email}
                  disabled
                />
              </div>
              <div className="flex flex-row mt-16">
                <Button
                  label={"Change Password"}
                  iconRight={PasswordCheck}
                  className="h-14 w-64 border border-bt-green font-sora font-medium2 text-bt-green rounded-full"
                  onClick={changePassword}
                  // onClick={() => {
                  //   history.push(`/account-settings/${id}/change-password`);
                  // }}
                />
              </div>
            </div>
          </div>
          <div className="flex flex-row justify-end mt-12">
            <Button
              label={"Save Changes"}
              iconLeft={Confirm}
              className="h-14 w-48 font-sora font-medium2 text-bt-white bg-bt-green rounded-full"
              onClick={() => edit()}
            />
          </div>
          <ToastContainer />
        </>
      }
    />
  );
};

export default AccountSettingsIndex;
